module.exports = __webpack_public_path__ + "img/women.ee5bbf40.png";